
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/logout",
      function () {
        return require("private-next-pages/logout.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/logout"])
      });
    }
  